import {
  SignUpElement,
  SignUpType,
  popSignUp,
} from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import {
  AnimatedWordPerfect,
  BannerContentTypography,
  RotatingLink,
} from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/BottomSignUpBannerStyles";
import { useGetBottomSignUpBannerUrls } from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/useGetBottomSignUpBannerProducts";
import { NonEnglishContent } from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/BottomSignUpBannerContent/NonEnglishContent";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { getLocaleKey } from "@faire/web/common/serialized-data/getLocaleKey";
import { Button } from "@faire/web/slate-deprecated/Button";
import { Column, Flex } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import isChromatic from "chromatic/isChromatic";
import React from "react";
import { useHistory } from "react-router-dom";

import { useIsLoggedOutHomepageV2 } from "../../../../useIsLoggedOutHomepageV2";

export const BottomSignUpBannerContent: React.FC = () => {
  const history = useHistory();
  return (
    <Column
      align="center"
      justify="center"
      className="relative text-center md:absolute"
    >
      <BannerContent />

      <Spacer
        height={{
          mobileAndAbove: "4x",
          desktopAndAbove: "5x",
        }}
      />
      <Button
        style={{ width: "fit-content" }}
        onClick={() =>
          popSignUp(history, SignUpType.GENERIC, () => null, {
            element: SignUpElement.BELOW_FOLD,
            sourceId: "logged_out_homepage_bottom_sign_up_banner",
          })
        }
      >
        <StrictLocalMsg
          id="7jfZHz"
          defaultMessage="Sign up for free"
          description={{
            text: "Logged out home page bottom banner cta button text",
          }}
        />
      </Button>
    </Column>
  );
};

const BannerContent: React.FC = () => {
  const isEnglish = getLocaleKey()?.language === Language.ENG;
  const { isXLargeAndAbove } = useViewport();
  const bottomSignUpBannerUrls = useGetBottomSignUpBannerUrls();
  const isHomepageRedesignV2 = useIsLoggedOutHomepageV2();
  const linkPositioning = isXLargeAndAbove
    ? ["329px", "361px", "316px", "370px", "364px"]
    : ["0", "0", "0", "0", "0"];

  if (!isEnglish) {
    return <NonEnglishContent />;
  }

  return (
    <BannerContentTypography>
      <AnimatedWordPerfect>The perfect</AnimatedWordPerfect>
      {bottomSignUpBannerUrls
        .slice(0, isChromatic() ? 1 : bottomSignUpBannerUrls.length)
        .map((content, index) => (
          <RotatingLink
            key={content.keyword}
            $index={index}
            $linkPositioning={linkPositioning}
            linkTo={content.url}
            onClick={() => {
              trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick(
                "perfect_product_banner-product-link",
                content.url,
                isHomepageRedesignV2 ? "v2" : "v1"
              );
            }}
          >
            <BannerContentTypography style={{ color: "unset" }}>
              {content.keyword}
            </BannerContentTypography>
          </RotatingLink>
        ))}
      <br />
      <Flex
        style={{ width: "100%" }}
        direction={{ mobileAndAbove: "column", xLargeAndAbove: "row" }}
        gap={{ mobileAndAbove: 4, xLargeAndAbove: "1x" }}
        align="center"
      >
        <div>for your store, </div>
        <div>right this way.</div>
      </Flex>
    </BannerContentTypography>
  );
};
